export const type = 'form.yesNo';
